import { dataContact } from '../utils/useData';
import SocialMedias from '../components/layouts/SocialMedias';
import FormContact from '../components/layouts/FormContact';
import Footer from '../components/layouts/Footer';

function Contact() {

    return (

        <>

            <div className='container animate__animated animate__fadeIn'>

                <section className='contact_container contact_c__border'>

                    <div className='box_title'>

                        <h2 className='title'>Como me encontrar:</h2>

                    </div>

                    <div className='box_txt'>

                        {dataContact()}

                        <SocialMedias type='social_description' />

                    </div>

                </section>

                <FormContact />

            </div>

            <Footer />

        </>

    )

}

export default Contact;